//PRUTL-frontend-npm6node14/src/pages/Home.jsx
import React from "react";
// import { Link } from "react-router-dom";
// import wallpaperImage from "../assets/kidsPulling.jpg";
// import wallpaperImageScrap from "../assets/scrap.jpg";
// import wallpaperImageOfficeCollegue from "../assets/officeCollegue.jpg";
// import wallpaperImageBalanceStones from "../assets/BalanceStones.jpg";
// import profileImage from "../assets/profileImage.png";
// import remarkProfileImage from "../assets/samGarcia.png";
// import logo from "../assets/prutl_logo.jpg";
import logo1 from "../assets/prutl_home1.jpg";
import logo2 from "../assets/prutl_home2.jpg";
import logo3 from "../assets/prutl_home3.jpg";
import logo4 from "../assets/prutl_home4.jpg";
import logo5 from "../assets/prutl_home5.jpg";
import logo6 from "../assets/prutl_home6.jpg";
import logo7 from "../assets/prutl_home7.jpg";
import sparkling from "../assets/sparkling.png";
import lightning from "../assets/lightning.png";
import lock from "../assets/lock.png";
import heart from "../assets/heart.png";
// import logo7 from "../../assets/prutl_home7.jpg";
const Home = () => {
  return (
    <div className="w-full min-h-screen bg-registerCard text-fontColor">
      {/* Header Section */}
      {/* <header className="flex justify-between items-center px-6 md:px-12 py-4 bg-white shadow-md">
        <img src={logo} alt="Logo" className="h-12" />
        <nav className="hidden md:flex space-x-6">
          <a href="#" className="text-gray-700 hover:text-black">Home</a>
          <a href="#" className="text-gray-700 hover:text-black">About</a>
          <a href="#" className="text-gray-700 hover:text-black">Events</a>
          <a href="#" className="text-gray-700 hover:text-black">Contact</a>
        </nav>
        <button className="bg-orange-500 text-white px-4 py-2 rounded-md hover:bg-orange-600">
          Get Started Today
        </button>
      </header> */}

      {/* Hero Section */}
      <section className="flex flex-col md:flex-row items-center px-6 md:px-12 py-12">
        <div className="md:w-1/2 space-y-4">
          <h1 className="text-3xl md:text-4xl font-bold">
            PASSIONIT RURAL UNITY TALENT LEAGUE Events
          </h1>
          <p className="text-gray-600">
            Igniting Rural Talent, Uniting Hearts, Inspiring Innovations.
          </p>
          <div className="flex space-x-4">
            <button className="border px-4 py-2 rounded-md buttonGray-bg hover:bg-buttonGray-bg">
              Discover More
            </button>
            <button className="bg-orange-500 text-white px-4 py-2 rounded-md hover:bg-orange-600">
              Get Started Today
            </button>
          </div>
          <p className="text-gray-600">
            Embrace a world of passion, talent, and togetherness with us
          </p>
        </div>
        <img
          src={logo1}
          alt="Hero"
          className="md:w-1/2 shadow-md mt-6 md:mt-0 h-96 border border-gray-300"
        />
      </section>

      {/* Vision Section */}
      <section className="px-6 md:px-12 py-12 flex flex-col md:flex-row items-center">
        <img
          src={logo2}
          alt="Vision"
          className="md:w-1/2 border border-gray-300 shadow-md"
        />
        <div className="md:w-1/2 md:pl-12 space-y-4 mt-6 md:mt-0">
          <h2 className="text-3xl font-bold">VISION</h2>
          <p className="text-gray-600">
            To empower rural communities globally by nurturing talent, fostering
            innovation, and strengthening family bonds through inclusive,
            soul-enriching games and events.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="px-6 md:px-12 py-12 flex flex-col md:flex-row items-center">
        <div className="md:w-1/2 space-y-4">
          <h2 className="text-3xl font-bold">MISSION</h2>
          <p className="text-gray-600">
            To create an engaging platform for rural students, parents, and
            educators to showcase their talents, foster creativity, and
            collaborate on innovative projects using the PASSION Dimensions
            framework, while promoting family togetherness and reducing
            over-reliance on social media.
          </p>
        </div>
        <img
          src={logo3}
          alt="Mission"
          className="md:w-1/2 border border-gray-300 shadow-md mt-6 md:mt-0"
        />
      </section>

      <section className="text-center py-12 px-4">
        <h2 className="text-3xl md:text-4xl font-semibold">
          Relevance to All Countries
        </h2>
        <p className="mt-4 text-justify max-w-5xl mx-auto text-gray-600">
          PASSIONIT PRUTL GAMES resonates universally as it taps into the shared
          need for community, creativity, and meaningful connections beyond
          digital platforms. By fostering local talent, promoting family
          engagement, and encouraging innovation, it addresses global challenges
          such as rural development, education, and social cohesion. Through the
          PASSION Dimensions, it empowers communities worldwide to leverage
          their unique cultural strengths, contributing to a more connected and
          innovative society.
        </p>
      </section>

      <section className="text-center py-12 px-4">
        <h1 className="text-4xl font-bold">PASSIONIT PRUTL GAMES</h1>
        <p className="text-gray-500 mt-2">
          Experience a world of opportunities and creativity
        </p>
      </section>

      <section>
        <div className="flex gap-0 justify-center items-center p-8">
          <div className="relative w-1/3">
            <img
              src={logo4}
              alt="Family Togetherness"
              className="w-full h-80 object-cover"
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="bg-white px-6 py-3 text-black font-semibold rounded-full shadow-lg">
                Family Togetherness
              </span>
            </div>
          </div>
          <div className="relative w-1/3">
            <img
              src={logo5}
              alt="Talent Showcase"
              className="w-full h-80 object-cover"
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="bg-white px-6 py-3 text-black font-semibold rounded-full shadow-lg">
                Talent Showcase
              </span>
            </div>
          </div>
          <div className="relative w-1/3">
            <img
              src={logo6}
              alt="Innovative Projects"
              className="w-full h-80 object-cover"
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="bg-white px-6 py-3 text-black font-semibold rounded-full shadow-lg">
                Innovative Projects
              </span>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="flex flex-col md:flex-row items-center justify-between p-10 gap-10">
          {/* Left Section */}
          <div className="md:w-1/2">
            <h2 className="text-3xl font-bold mb-6">
              Empowering Rural Communities Globally
            </h2>

            {/* Local Talent */}
            <div className="p-3 mb-3 border border-gray-300 rounded-lg bg-white flex items-center justify-center w-12 h-12">
              <img src={sparkling} alt="Local Talent" className="w-6 h-6" />
            </div>
            <div className="flex items-start gap-4 mb-6">
              <div>
                <h3 className="text-lg font-semibold">Local Talent</h3>
                <p className="text-gray-600">
                  Empower individuals to shine in their unique abilities
                </p>
                <a
                  href="#"
                  className="text-orange-600 font-semibold mt-2 inline-block"
                >
                  Discover More
                </a>
              </div>
            </div>

            {/* Family Engagement */}
            <div className="p-3 my-3 border border-gray-300 rounded-lg bg-white flex items-center justify-center w-12 h-12">
              <img
                src={lightning}
                alt="Family Engagement"
                className="w-6 h-6"
              />
            </div>
            <div className="flex items-start gap-4">
              <div>
                <h3 className="text-lg font-semibold">Family Engagement</h3>
                <p className="text-gray-600">
                  Strengthen bonds through interactive activities
                </p>
                <a
                  href="#"
                  className="text-orange-600 font-semibold mt-2 inline-block"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>

          {/* Right Section - Image */}
          <div className="md:w-1/2">
            <img
              src={logo7}
              alt="Empowering Communities"
              className="w-full h-auto border border-gray-300"
            />
          </div>
        </div>
      </section>

      <section>
        <div className="px-8 py-12 max-w-full mx-auto">
          <h2 className="text-3xl font-bold text-black mb-8">
            Join the Global Movement of Empowerment
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center border border-gray-400 rounded-lg">
                <span className="text-2xl">
                  {" "}
                  <div className="p-3 my-3 border border-gray-300 rounded-lg bg-white flex items-center justify-center w-12 h-12">
                    <img
                      src={lightning}
                      alt="Holistic Development"
                      className="w-6 h-6"
                    />
                  </div>
                </span>
              </div>
              <div>
                <h3 className="text-lg font-bold">Holistic Development</h3>
                <p className="text-gray-600">
                  Grow in all dimensions with PASSION Dimensions framework
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center border border-gray-400 rounded-lg">
                <span className="text-2xl">
                  {" "}
                  <div className="p-3 my-3 border border-gray-300 rounded-lg bg-white flex items-center justify-center w-12 h-12">
                    <img
                      src={sparkling}
                      alt="Economic Growth"
                      className="w-6 h-6"
                    />
                  </div>
                </span>
              </div>
              <div>
                <h3 className="text-lg font-bold">Economic Growth</h3>
                <p className="text-gray-600">
                  Opportunities for educational and economic advancement
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center border border-gray-400 rounded-lg">
                <span className="text-2xl">
                  {" "}
                  <div className="p-3 my-3 border border-gray-300 rounded-lg bg-white flex items-center justify-center w-12 h-12">
                    <img
                      src={lock}
                      alt="Cultural Enrichment"
                      className="w-6 h-6"
                    />
                  </div>
                </span>
              </div>
              <div>
                <h3 className="text-lg font-bold">Cultural Enrichment</h3>
                <p className="text-gray-600">
                  Celebrate diversity and shared experiences
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center border border-gray-400 rounded-lg">
                <span className="text-2xl">
                  {" "}
                  <div className="p-3 my-3 border border-gray-300 rounded-lg bg-white flex items-center justify-center w-12 h-12">
                    <img
                      src={heart}
                      alt="Community Unity"
                      className="w-6 h-6"
                    />
                  </div>
                </span>
              </div>
              <div>
                <h3 className="text-lg font-bold">Community Unity</h3>
                <p className="text-gray-600">
                  Bridge social gaps and unite communities
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

     
    </div>
  );
};

export default Home;

// *****************************************************************************\
// import React from "react";
// import { Link } from "react-router-dom";
// import wallpaperImage from "../assets/kidsPulling.jpg";
// import wallpaperImageScrap from "../assets/scrap.jpg";
// import wallpaperImageOfficeCollegue from "../assets/officeCollegue.jpg";
// import wallpaperImageBalanceStones from "../assets/BalanceStones.jpg";
// import profileImage from "../assets/profileImage.png";
// import remarkProfileImage from "../assets/samGarcia.png";

// const Home = () => {
//   return (
//     <div className=" text-gray-800">
//       {/* PRUTL Header */}
//       <div className="text-center py-16 bottom-remark-card text-white">
//         <h1 className="text-4xl font-bold uppercase">
//           PASSIONIT RURAL UNITY TALENT LEAGUE (PRUTL)
//         </h1>
//         <p className="mt-2 text-lg font-light italic">
//           “Igniting Rural Talent, Uniting Hearts, Inspiring Innovations.”
//         </p>
//       </div>

//       {/* Vision & Mission Section */}
//       <div className="max-w-6xl mx-auto px-6 py-16">
//         <div className="grid md:grid-cols-2 gap-8">
//           {/* Vision */}
//           <div className="p-8 bg-white shadow-lg rounded-lg loginFormContainer">
//             <h2 className="text-2xl font-bold footerLink mb-4">Our Vision</h2>
//             <p className="text-gray-700 leading-relaxed">
//               To empower rural communities globally by nurturing talent,
//               fostering innovation, and strengthening family bonds through
//               inclusive, soul-enriching games and events.
//             </p>
//           </div>

//           {/* Mission */}
//           <div className="p-8 bg-white shadow-lg rounded-lg loginFormContainer">
//             <h2 className="text-2xl font-bold footerLink mb-4">Our Mission</h2>
//             <p className="text-gray-700 leading-relaxed">
//               To create an engaging platform for rural students, parents, and
//               educators to showcase their talents, foster creativity, and
//               collaborate on innovative projects using the PASSION Dimensions
//               framework. We aim to promote family togetherness and reduce
//               over-reliance on social media.
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Relevance to All Countries */}
//       <div className="text-white py-16 bottom-remark-card">
//         <div className="max-w-4xl mx-auto px-6 text-center">
//           <h2 className="text-3xl font-bold">Relevance to All Countries</h2>
//           <p className="mt-4 text-lg leading-relaxed">
//             PASSIONIT PRUTL GAMES resonates universally as it taps into the
//             shared need for community, creativity, and meaningful connections
//             beyond digital platforms. By fostering local talent, promoting
//             family engagement, and encouraging innovation, it addresses global
//             challenges such as rural development, education, and social
//             cohesion. Through the PASSION Dimensions, it empowers communities
//             worldwide to leverage their unique cultural strengths, contributing
//             to a more connected and innovative society.
//           </p>
//         </div>
//       </div>

//       {/* Features Section */}
//       <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-8">
//         {/* Feature 1 */}
//         <div className="p-8 bg-white shadow-lg rounded-lg flex flex-col items-center loginFormContainer">
//           <img
//             src={wallpaperImage}
//             alt="Collaborate with Experts"
//             className="w-48 h-48 object-cover rounded-lg"
//           />
//           <h3 className="mt-6 text-xl font-bold text-home">
//             Collaborate with Diverse Experts
//           </h3>
//           <p className="mt-2 text-center text-gray-700">
//             Access a network of academicians, researchers, and mentors to bring
//             your ideas to life.
//           </p>
//         </div>

//         {/* Feature 2 */}
//         <div className="p-8 bg-white shadow-lg rounded-lg flex flex-col items-center loginFormContainer">
//           <img
//             src={wallpaperImageScrap}
//             alt="Convert Ideas"
//             className="w-48 h-48 object-cover rounded-lg"
//           />
//           <h3 className="mt-6 text-xl font-bold text-home">
//             Convert Ideas into Products
//           </h3>
//           <p className="mt-2 text-center text-gray-700">
//             Work with professionals to refine concepts and create innovative
//             solutions.
//           </p>
//         </div>

//         {/* Feature 3 */}
//         <div className="p-8 bg-white shadow-lg rounded-lg flex flex-col items-center loginFormContainer">
//           <img
//             src={wallpaperImageOfficeCollegue}
//             alt="Efficient Project Management"
//             className="w-48 h-48 object-cover rounded-lg"
//           />
//           <h3 className="mt-6 text-xl font-bold text-home">
//             Efficient Project Management
//           </h3>
//           <p className="mt-2 text-center text-gray-700">
//             Utilize cutting-edge tools to streamline projects and ensure
//             efficiency.
//           </p>
//         </div>

//         {/* Feature 4 */}
//         <div className="p-8 bg-white shadow-lg rounded-lg flex flex-col items-center loginFormContainer">
//           <img
//             src={wallpaperImageBalanceStones}
//             alt="Revenue Optimization"
//             className="w-48 h-48 object-cover rounded-lg"
//           />
//           <h3 className="mt-6 text-xl font-bold text-home">
//             Revenue Optimization
//           </h3>
//           <p className="mt-2 text-center text-gray-700">
//             Maximize revenue opportunities by leveraging our expert guidance and
//             resources.
//           </p>
//         </div>
//       </div>

//       {/* Testimonials */}
//       <div className="loginFormContainer py-16 ">
//         <div className="max-w-4xl mx-auto text-center">
//           <h2 className="text-3xl font-bold text-home">What People Say</h2>
//           <div className="mt-8 flex flex-col md:flex-row items-center gap-6">
//             <div className="bg-white p-6 shadow-lg rounded-lg w-full bottom-remark-card">
//               <p className="text-gray-700">
//                 "PRUTL has been instrumental in transforming my ideas into
//                 profitable products. The collaborative environment and expert
//                 guidance have significantly boosted my project success."
//               </p>
//               <div className="flex items-center mt-4">
//                 <img
//                   src={remarkProfileImage}
//                   alt="Sam Garcia"
//                   className="w-12 h-12 rounded-full"
//                 />
//                 <span className="ml-4 text-gray-800 font-bold">Sam Garcia</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Call to Action */}
//       <div className="text-center py-16 ">
//         <h2 className="text-3xl font-bold text-home">Join Us Today</h2>
//         <p className="mt-4 text-gray-700">
//           Be part of a revolutionary platform that empowers rural talent and
//           fosters global collaboration.
//         </p>
//         <Link
//           to="/contactUs"
//           className="mt-6 inline-block button-bg text-white px-6 py-3 rounded-lg text-lg font-semibold "
//         >
//           Contact Us
//         </Link>
//       </div>
//     </div>
//   );
// };

// export default Home;
